import { ol_Feature, ol_geom } from "@omnia/exports/openlayers";
import { isNumber } from "../omnia";

export class GcpPoint {

    public number: number;

    public map: ol_Feature;
    public raster: ol_Feature;

    public isComplete(): boolean {
        return (!!this.map) && (!!this.raster);
    }

    public getMapCoord(): number[] {
        return this.getFeatureCoord(this.map);
    }

    public getMapCoordXY(): { X: number, Y: number } {
        return this.getFeatureCoordXY(this.map, null);
    }

    public getRasterCoord(): number[] {
        return this.getFeatureCoord(this.raster);
    }

    public getRasterCoordXY(flipY: number): { X: number, Y: number } {
        return this.getFeatureCoordXY(this.raster, flipY);
    }

    private getFeatureCoordXY(feature: ol_Feature, flipY: number): { X: number, Y: number } {

        let coord = this.getFeatureCoord(feature);
        if (!coord) return null;

        let y = coord[1];
        if (isNumber(flipY)) {
            y = flipY - y;
        }

        return { X: coord[0], Y: y };

    }

    private getFeatureCoord(feature: ol_Feature): number[] {
        if (!feature) return null;
        let geom = feature.getGeometry();
        if (geom instanceof ol_geom.Point) {
            return geom.getFirstCoordinate();
        }
    }

}
